import React, { useState, useEffect } from "react";
import "./Tag.css";
import { AppState } from "../model/AppState";

type TagProps = {
	name: string;
	state: AppState;
};

const Tag: React.FunctionComponent<TagProps> = (props: TagProps) => {
	const [isSelected, setSelected] = useState(
		props.state.getTagSelection(props.name)
	);

	function onClick() {
		props.state.setTagSelection(props.name, !props.state.getTagSelection(props.name));
	}

	useEffect(() => {
		const onTagSelectionChanged = (tag: string, selected: boolean) => {
			if (tag === props.name) {
				setSelected(selected);
			}
		};

		props.state.addListener(onTagSelectionChanged);

		return () => props.state.removeListener(onTagSelectionChanged);
	});

	const tagSelectionClass = isSelected ? "Tag-selected" : "Tag-unselected";
	return (
		<span
			className={`Tag ${tagSelectionClass} w3-tag w3-border w3-round`}
			onClick={onClick}
		>
			{props.name}
		</span>
	);
};

export default Tag;
